<template>
  <headers />
  <div class="info">
    <h3>个人信息核对与采集</h3>
    <form
      class="el-form demo-table-expand el-form--label-left el-form--inline"
      :model="ruleForm.datas"
    >
      <el-divider content-position="left"><h4>学生信息</h4> </el-divider>

      <el-row :gutter="20">
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">学号：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_No
          }}</label>
        </el-col>
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">姓名：</label>

          <label class="el-form-item__text">{{
            ruleForm.datas.student_Name
          }}</label>
        </el-col>
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">拼音码：</label>

          <label class="el-form-item__text">{{
            ruleForm.datas.student_Name_Spell
          }}</label>
        </el-col>

        <el-col :span="6" :lg="6" :xs="12">
          <el-image
            :src="ruleForm.datas.student_Photo"
            class="avatar"
            style="
              margin: 10px auto;
              float: right;
              height: 150px;
              width: 120px;
              position: absolute;
              right: 6%;
            "
          ></el-image>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">身份证：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_IDnumber
          }}</label>
        </el-col>
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">性别：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_Sex
          }}</label>
        </el-col>
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">生日：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_Birthday
          }}</label>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">学生类型：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_Type
          }}</label>
        </el-col>

        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">年级：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_Grade
          }}</label>
        </el-col>
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">学制：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_Years
          }}</label>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">民族：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_mz
          }}</label>
        </el-col>
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">政治面貌：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_Zzmm
          }}</label>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">入学时间：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_Entrance_DateStr
          }}</label>
        </el-col>
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">毕业时间：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_Leave_DateStr
          }}</label>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">院系：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_Dept
          }}</label>
        </el-col>
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">专业：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_Specialty
          }}</label>
        </el-col>
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright">班级：</label>
          <label class="el-form-item__text">{{
            ruleForm.datas.student_Class
          }}</label>
        </el-col>
        <el-col :span="3" :lg="3" :xs="12">
          <el-upload
            style="float: left; margin-left: -25px"
            class="avatar-uploader"
            action="#"
            :show-file-list="false"
            accept="image/*"
            :http-request="upload"
          >
            <el-button size="mini" type="primary" class="el-button-upload"
              >上传<i class="el-icon-upload el-icon--right"></i
            ></el-button>
          </el-upload>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright"
            ><i class="redstart">* </i> 手机号：</label
          >
          <label class="el-form-item__text">
            <el-input
              placeholder="请输入手机号"
              v-model="ruleForm.datas.student_Mobile"
              clearable
            >
            </el-input>
          </label>
        </el-col>
        <el-col :span="7" :lg="7" :xs="12">
          <label class="el-form-item__labelright"
            >邮箱：</label
          >
          <label class="el-form-item__text">
            <el-input
              placeholder="请输入邮箱"
              v-model="ruleForm.datas.student_Email"
              clearable
            >
            </el-input>
          </label>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24" :lg="24" :xs="24">
          <label class="el-form-item__labelright"
            ><i class="redstart">* </i>生活习性：</label
          >
          <label class="el-form-item__text3" style="width: 92%">
            <el-checkbox-group v-model="ruleForm.checkList">
              <el-checkbox
                v-for="data in ruleForm.dbbook"
                :label="data.id + ':' + data.name"
                :key="data.serial"
              >
                {{ data.name }}
              </el-checkbox>
            </el-checkbox-group>
          </label>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="24" :lg="24" :xs="24">
          <label class="el-form-item__labelright">备注：</label>
          <p class="el-form-item__text1">
            <el-input
              type="textarea"
              :autosize="{ minRows: 2, maxRows: 4 }"
              placeholder="请输入内容"
              v-model="ruleForm.datas.student_Memo"
            >
            </el-input>
          </p>
        </el-col>
      </el-row>
      <el-divider content-position="left"><h4>家庭信息</h4> </el-divider>
      <el-row :gutter="20">
        <el-col :span="8" :lg="8" :xs="12">
          <label class="el-form-item__labelright">父/母姓名：</label>
          <label class="el-form-item__text3">
            <el-input
              placeholder="请输入父/母姓名"
              v-model="ruleForm.datas.student_Home_Parents"
              clearable
            >
            </el-input>
          </label>
        </el-col>
        <el-col :span="8" :lg="8" :xs="12">
          <label class="el-form-item__labelright">家庭电话：</label>
          <label class="el-form-item__text3">
            <el-input
              placeholder="请输入家庭电话："
              v-model="ruleForm.datas.student_Home_Mobile"
              clearable
            >
            </el-input
          ></label>
        </el-col>
        <el-col :span="8" :lg="8" :xs="12">
          <label class="el-form-item__labelright">籍贯：</label>
          <label class="el-form-item__text3">
            <el-input
              placeholder="请输入籍贯"
              v-model="ruleForm.datas.student_NativePlace"
              clearable
            >
            </el-input
          ></label>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="16" :lg="16" :xs="12">
          <label class="el-form-item__labelright">家庭地址：</label>
          <label class="el-form-item__text3" style="width: 88%">
            <el-input
              placeholder="请输入家庭电话："
              v-model="ruleForm.datas.student_Home_address"
              clearable
            >
            </el-input>
          </label>
        </el-col>
        <el-col :span="8" :lg="8" :xs="12">
          <label class="el-form-item__labelright">邮编：</label>
          <label class="el-form-item__text3">
            <el-input
              placeholder="请输入内容"
              v-model="ruleForm.datas.student_Home_Code"
              clearable
            >
            </el-input>
          </label>
        </el-col>
      </el-row>

      <el-divider></el-divider>
      <el-row>
        <el-col :span="8" :lg="8"></el-col>
        <el-col :span="8" :lg="8">
          <el-button class="el-button-cuc" @click="onSubmit(ruleForm.datas)"
            >提交（提交后进入下一步"我要选床"）</el-button
          ></el-col
        >
        <el-col :span="8" :lg="8"></el-col>
      </el-row>
    </form>
  </div>
</template>
<style lang="scss" scoped>
.redstart {
  color: red;
}
.el-button-cuc,
.el-button-cuc:hover,
.el-button-cuc:focus {
  float: left;
  background-image: none;
  background-color: #059490;
  width: calc(100% - 40px);
  line-height: 1;
  padding: 10px 0;
  cursor: pointer;
  border: 1px solid #04726f;
  font-family: "Microsoft YaHei";
  font-size: 16px;
  height: 50px;
  line-height: 30px;
  border-radius: 6px;
  margin: 8px 0 0 21px;
  color: #fff;
  text-align: center;
  position: relative;
  box-sizing: border-box;
}
.el-button-upload,
.el-button-upload:hover,
.el-button-upload:focus {
  background-color: #059490;
  color: #fff;
}
.el-form-item__text {
  text-align: left;
  width: 70%;
  display: inline-block;
  line-height: 40px;
}
.el-form-item__text3 {
  margin: 2px 0;
  text-align: left;
  width: 75%;
  display: inline-block;
  line-height: 40px;
}
.el-form-item__text1 {
  text-align: left;
  width: 92%;
  display: inline-block;
  line-height: 40px;
}
.el-form-item__labelright {
  text-align: right;
  width: 92px;
  color: #080808;
  vertical-align: middle;
  float: left;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
  padding: 0 12px 0 0;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-form-item {
  margin-bottom: 0px;
}
.info {
  width: 98%;
  max-width: 1180px;
  margin: 0 auto;
  padding: 20px 50px;
}
</style>
<script>
import headers from "../views/Home.vue";
import { getStudent } from "../http/api.ts";
import { GetDbook } from "../http/api.ts";
import { GetStudentXG } from "../http/api.ts";
import { SaveStudentInfo } from "../http/api.ts";
import { InsertPicture } from "../http/api.ts";
import { baseurl } from "../http/api.ts";
import { getTime } from "../http/api.ts";
import { reactive } from "vue";
import Route from "../router/index";
import { ref } from "vue";
import { ElMessage } from "element-plus";
import Qs from "qs";

export default {
  components: {
    headers,
  },
  setup() {
    let ruleForm = reactive({
      datas: [],
      dbbook: [],
      checkList: [],
    });

    let imgs = ref("");
    //let checkList = ref([]);
    let dataFun = async () => {
      await getStudent().then((res) => {
        ruleForm.datas = res.datas;
      });
      await GetDbook("学生生活习性").then((res) => {
        ruleForm.dbbook = res.datas;
      });
      await GetStudentXG(ruleForm.datas.id).then((res) => {
        const list = [];
        res.datas.forEach((element) => {
          list.push(element.habitsId + ":" + element.habitsName);
        });
        ruleForm.checkList = ref(list);
      });
    };
    dataFun();

    return {
      ruleForm,
      imgs,
    };
  },
  methods: {
    onSubmit(rule) {
      getTime().then((res) => {
        if (!res.datas) {
          ElMessage.error({message:res.msg,offset: 300});
        } else {
          if (
            rule.student_Mobile.length == 0 ||
            this.ruleForm.checkList.length == 0
          ) {
            this.$message({
              message: "带*号的为必填项，不能为空",
              type: "error",
              offset: 300,
              duration: 3000,
            });
            return false;
          }
          const loading = this.$loading({
            lock: true,
            text: "提交中...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          rule.checkList = this.ruleForm.checkList;
          SaveStudentInfo(Qs.stringify(rule)).then((res) => {
            if (res.code == 200) {
              ElMessage.success({message:'个人信息保存成功！',offset: 300});
              setTimeout(() => {
                  Route.push("/house?tmsite="+Math.random());
              }, 1500);
            } else {
              ElMessage.error({message:res.msg,offset: 300});
            }
          });
          loading.close();
        }
      });
    },
    upload(e) {
      //这是参数配置，可以忽略
      // const tthash = window.btoa(
      //   window
      //     .btoa(encodeURI(location.hash.replace("#/", "") ?? ""))
      //     .split("")
      //     .reverse()
      //     .join("")
      // );
      //使用FormData 的最大优点就是可以异步上传二进制文件。
      //而图片，文件之类的文件是二进制，接口接收参数也是接收的二进制
      //可以先通过new关键字创建一个空的 FormData 对象，然后使用 append() 方法向该对象里添加字段
      //（字段的值可以是一个 Blob 对象，File对象或者字符串，剩下其他类型的值都会被自动转换成字符串）。
      //也可以用一个已有的form元素来初始化FormData对象
      const formData = new FormData();

      //这里是把上传接口所有的参数都append到formData中
      formData.append("img", e.file);
      formData.append("type", "market");
      formData.append("grade", this.ruleForm.datas.student_Grade);
      formData.append("ttname", location.pathname.replace("/", ""));
      formData.append("stuno", this.ruleForm.datas.student_No);
      formData.append(
        "tenantCode",
        process.env.NODE_ENV === "development"
          ? process.env.VUE_APP_TENANT_CODE
          : ""
      );
      formData.append(
        "productCode",
        process.env.NODE_ENV === "development"
          ? process.env.VUE_APP_PRODUCT_CODE
          : ""
      );
      InsertPicture(formData).then((res) => {
        if (res.msg == "上传成功") {
          ElMessage.success({message:res.msg,offset: 300});
          this.ruleForm.datas.student_Photo =
            baseurl + res.datas + "?" + new Date().getTime();
        } else {
          ElMessage.error({message:res.msg,offset: 300});
        }
      });
    },
  },
};
</script>